/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EduContentHighScoreInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class EduContentHighScoreApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'EduContentHighScores');
  }

  getHighScores(eduContentId: number, personId: number): Observable<EduContentHighScoreInterface[]> {
    const path = `${eduContentId}`;
    const params = this._getHttpParams({ personId });
    return this.get<EduContentHighScoreInterface[]>(path, params);
  }

  updateHighScore(eduContentId: number, personId: number, score: number): Observable<EduContentHighScoreInterface> {
    const path = `${eduContentId}/${personId}`;
    return this.post<EduContentHighScoreInterface>(path, undefined, score as any);
  }
}
